import React from 'react';
import PropTypes from 'prop-types';
import requiredIf from 'react-required-if';
import { Button, Row, Col } from 'react-bootstrap';
import { unicode, annotation as constants } from './../helpers';
import ConditionalComponent from './ConditionalComponent';

const FeedbackComponent = ({
  title,
  isDisabled,
  disabledText,
  upVoteCount,
  downVoteCount,
  currentVote,
  onVoteClick,
  onCommentClick,
  onShowCommentsClick
}) => {

  const userNameDependentAction = (newValue) => localStorage.getItem('userName') ?
    onVoteClick(newValue, currentVote) :
    onCommentClick();

  // if we find we need non-binary feedback we can extend this to accept
  // list of options in props and generate from there
  const feedbackItems = (
    <div>
      <Row>
        <Col md={12}>
          <Button
            id={'up-vote-btn'}
            onClick={() =>
              userNameDependentAction(constants.ALL_ANNOTATIONS_STATUSES.UP_VOTE)}
            active={currentVote.status ===
               constants.ALL_ANNOTATIONS_STATUSES.UP_VOTE}
          >
            {`${unicode.THUMBS_UP} ${upVoteCount}`}
          </Button>
          <Button
            id={'down-vote-btn'}
            onClick={() =>
              userNameDependentAction(constants.ALL_ANNOTATIONS_STATUSES.DOWN_VOTE)}
            active={currentVote.status ===
              constants.ALL_ANNOTATIONS_STATUSES.DOWN_VOTE}
          >
            {`${unicode.THUMBS_DOWN} ${downVoteCount}`}
          </Button>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Button
            id={'add-feedback-btn'}
            onClick={() => onCommentClick()}
          >
            Add Comment
          </Button>
          <Button
            id={'show-comments-btn'}
            onClick={() => onShowCommentsClick()}
          >
            Show Comments
          </Button>
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <legend>{title}:</legend>
      <ConditionalComponent
        condition={!isDisabled}
        children={feedbackItems}
        elseChildren={disabledText}
      />
    </div>
  );
};

FeedbackComponent.propTypes = {
  title: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  disabledText: requiredIf(PropTypes.string,
    props => props.isDisabled),
  upVoteCount: PropTypes.number.isRequired,
  downVoteCount: PropTypes.number.isRequired,
  voteTotal: PropTypes.number.isRequired,
  currentVote: PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired
  }).isRequired,
  onVoteClick: PropTypes.func.isRequired,
  onCommentClick: PropTypes.func.isRequired,
  onShowCommentsClick: PropTypes.func.isRequired
};

export default FeedbackComponent;


// WEBPACK FOOTER //
// src/Components/FeedbackComponent.jsx